import React from 'react';
import EndPier4Board from './EndPier4Board';

const EndPier4 = () => <EndPier4Board />;

export default EndPier4;
